import StoreLocationForm from './StoreLocationForm'

export default StoreLocationForm
